module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueMiniParcours_ScienceMd.92284e3f.png";